import { forwardRef, Module } from '@nestjs/common';
import { AuthService } from './auth.service';
import { AuthController } from './auth.controller';
import { PassportModule} from '../passport/passport.module';
import {JwtModule} from '@nestjs/jwt';
import {JwtStrategy} from './jwt.strategy'
import {UserModule} from '../user/user.module';
require('dotenv').config();
@Module({
  imports:[ 
    forwardRef(() =>UserModule),
    forwardRef(()=>PassportModule.register({      
    defaultStrategy: 'jwt',      
    property: 'user',      
    session: false,    
  })),
  forwardRef(() => JwtModule.register({
    secret: 'varaha',//process.env.SECRETKEY, 
    signOptions: {
       // expiresIn: '1h',//process.env.EXPIRESIN,
    },
  })),
  ],
  providers: [AuthService,JwtStrategy],
  controllers: [AuthController]
})
export class AuthModule {}
